import React, { useState, useEffect, Fragment } from 'react';
import { putESGAssessment, getEsgCategories } from '@lib/api';
import { SuccessToast, DangerToast } from '@components/GlobalToastList';
import ScrollArrow from '@components/ScrollArrow';
import TutorialsButtonWrapper from 'components/TutorialsButtonWrapper';
import EsgComponent from 'components/QuestionnaireComponents/esgComponent';
import QuestionnaireInstructionComponent from 'components/QuestionnaireComponents/QuestionnaireInstructionComponent';

const ValutazioneESGNEW = ({
  currentProject,
  translations,
  isMonitoring,
  monitoringVersion,
  isInMonitoring,
  setIsLoading,
  isLoading,
}) => {
  const [questions, setQuestions] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [project, setProject] = useState(currentProject);
  // const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!currentProject) return;

    setProject(currentProject);
    setQuestions(currentProject.questions ?? []);

    const mappedAssessment =
      currentProject.esgassessments
        ?.filter((el) => el?.answers && el?.answers?.length > 0)
        ?.map((el) => {
          const answers = el.answers.map((answer) => ({
            answerId: Number(answer.id),
            value: answer.value,
          }));

          // se ogni esgassessment è per una sola domanda,
          // prendo il questionId dal primo answer
          const questionId = Number(el.answers[0]?.questionId);

          return { questionId, answers };
        })
        .sort((a, b) => a.questionId - b.questionId) ?? [];

    setAssessment(mappedAssessment);
  }, [currentProject]);

  const handleSave = (e) => {
    const form = document.getElementById('valutazione-esg-form');
    const inputs = Array.from(form.elements).filter((el) => el.nodeName === 'INPUT');
    const isInvalid = inputs.some((input) => !input.checkValidity());

    if (isInvalid) {
      const accordions = Array.from(form.getElementsByClassName('collapse'));

      accordions.forEach((accordion) => {
        accordion.classList.add('show');
      });

      form.reportValidity();
    } else {
      submit(e);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const request = assessment
        .filter(
          (asses) =>
            asses?.questionId != null &&
            Array.isArray(asses?.answers) &&
            asses?.answers?.length > 0,
        )
        .map((asses) => ({
          questionId: Number(asses.questionId),
          answers: asses.answers.map((answ) => ({
            answerId: Number(answ.answerId),
            value: answ.value,
          })),
        }));

      const result = await putESGAssessment(project.id, request, monitoringVersion);

      if (!result) {
        DangerToast('Attenzione', 'Errore nella modifica del progetto');
        return;
      }

      SuccessToast('Operazione conclusa', 'Progetto modificato correttamente');

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error('Errore in submit ESG assessment:', error);
      DangerToast('Attenzione', 'Si è verificato un errore inatteso');
    } finally {
      // viene eseguito sia in caso di successo che di errore
      setIsLoading(false);
    }
  };
  return (
    <>
      <QuestionnaireInstructionComponent translations={translations} />
      {questions && assessment && (
        <EsgComponent
          questionsData={questions}
          answersData={assessment}
          setAnswersData={setAssessment}
          postFunction={handleSave}
          isLoading={isLoading}
          formId='valutazione-esg-form'
          translations={translations}
          isButtonVisible={
            !isInMonitoring
              ? project.status === 'DRAFT'
              : isMonitoring && +monitoringVersion === currentProject?.ver
          }
          areInputsDisabled={
            !isInMonitoring
              ? project.status === 'DELETED' || project.status === 'SUBMITTED' || isLoading
              : !isMonitoring || (isMonitoring && +monitoringVersion !== currentProject?.ver)
          }
          isMonitoring={isMonitoring}
          // sbShow={sbShow}
        />
      )}
      <TutorialsButtonWrapper
        url={'https://www.youtube.com/embed/SvMp1A6m1y8?si=1waFfI5dJxP7sLf9'}
        videoTitle={'Tutorial Questionario ESG'}
      />

      <ScrollArrow />
    </>
  );
};
export default ValutazioneESGNEW;
